export class BaseOfferDto {
  public StatusCode: string;
  public PropertyAddress: string;
  public ValidityDate?: Date;
  public Version?: number;
  public SendDate?: Date;
  public CustomerNumberCount: number;
}
